import { Endpoint } from '@philips-emr/hpms-provider-accreditation-commons/lib/constants';
import { FormAPI } from '@philips-emr/tws-components';
import Controller, { OnMount, OnSubmit } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { FormTechnicalVisitAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

interface SubObject {
  code: number;
  description: string;
  ieRequired: string;
}

@Controller({ fragment: FragmentNames.FORM_TECHNICAL_VISIT })
export default class FormTechnicalVisitController extends BaseController {

  @OnMount(FormTechnicalVisitAliases.HPMS_FORM_TECHNICAL_VISIT)
  public onMount(event: MountEvent): void {
    const api = event.target as FormAPI;
    api.setEditing(true);
  }

  @OnSubmit(FormTechnicalVisitAliases.HPMS_FORM_TECHNICAL_VISIT)
  public onSubmitForm(event: FormAPI): void {
    this.handlerSubmit(event);
  }

  handlerSubmit(event: FormAPI): void {
    const recordsDsjustification = [];
    const recordsAutoComplete: { nrSeqFormPr: number; nrSeqAnswer: number | null; }[] = [];
    let nrSeqFormPr, nrSeqAnswer;

    for (const [key, value] of Object.entries(event.record)) {

      if (!key.includes('label__')) {

        if (key.includes('answers__')) {
          nrSeqFormPr = Number(key.split('answers__')[1]);
          nrSeqAnswer = (value as SubObject).code || null;
          recordsAutoComplete.push({ 'nrSeqFormPr': nrSeqFormPr, 'nrSeqAnswer': nrSeqAnswer });
        }

        if (key.includes('justification__')) {
          nrSeqFormPr = Number(key.split('justification__')[1]);
          recordsDsjustification.push({ 'nrSeqFormPr': nrSeqFormPr, 'dsJustification': value });
        }
      }
    }

    const answersForm = recordsDsjustification.map((justification) => ({
      ...recordsAutoComplete.find((o) => o.nrSeqFormPr === justification.nrSeqFormPr),
      ...justification,
    })) as unknown as any;

    const { nrSeqVisit } = this.historyService.getCurrentRouteParams();
    void HttpService.post(Endpoint.POST.FORM_TECHNICAL_VISIT, { nrSeqVisit }, { body: answersForm });
  }
}
